import React, { useId } from "react";
import "./WelcomeWave.css";
import { t } from "../i18n";

// The Requests dashboard's greeting (founder, build 44): "Welcome" and a waving
// hand drawn after 👋 — our own drawing, never the emoji. It waves twice when
// the page opens; prefers-reduced-motion keeps it still.
const SHAPES = (
  <>
    <rect x="13.4" y="19" width="6.6" height="24" rx="3.3" transform="rotate(-9 16.7 40)" />
    <rect x="20.6" y="11.5" width="7.3" height="30" rx="3.65" transform="rotate(-4 24.2 40)" />
    <rect x="28.4" y="8.5" width="7.4" height="32" rx="3.7" />
    <rect x="36.2" y="12" width="7.2" height="29" rx="3.6" transform="rotate(5 39.8 40)" />
    <rect x="43.2" y="28.5" width="7.8" height="21" rx="3.9" transform="rotate(34 47.1 47)" />
    <path d="M13.6 34h31.2l2.4 9.2c.8 9.6-6.6 16.8-16.2 16.8-8.6 0-14.8-5.8-16-13.6Z" />
  </>
);

export const WavingHand: React.FC = () => {
  // useId's ":r1:" is not a safe url(#…) fragment everywhere.
  const id = `wv${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  return (
    <svg className="welcome-hand" viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id={id} gradientUnits="userSpaceOnUse" x1="20" y1="6" x2="36" y2="62">
          <stop offset="0" stopColor="#FFE071" />
          <stop offset="0.55" stopColor="#FFC93C" />
          <stop offset="1" stopColor="#F4A62A" />
        </linearGradient>
      </defs>
      <g className="welcome-hand-wave">
        <g transform="rotate(-30 31 38)">
          <g fill="#C97F14" transform="translate(0.9 1.3)">{SHAPES}</g>
          <g fill={`url(#${id})`}>{SHAPES}</g>
        </g>
      </g>
      <g stroke="#9CA3AF" strokeWidth="2.4" fill="none" strokeLinecap="round" opacity="0.85">
        <path d="M47 6.5c2.6 1.3 4.6 3.4 5.8 6" />
        <path d="M49.5 1.8c3.6 1.8 6.4 4.7 8 8.3" />
        <path d="M5.8 44.5c.6 3 2.2 5.6 4.6 7.4" />
        <path d="M1.6 46c.9 4.2 3.2 7.8 6.6 10.3" />
      </g>
    </svg>
  );
};

const WelcomeWave: React.FC = () => (
  <div className="welcome-wave">
    {t("requestsPage.welcome")}
    <WavingHand />
  </div>
);

export default WelcomeWave;
